module.exports = __webpack_public_path__ + "components/star-rating/static/white/7-3b4047a758eb9ef3056614f14905cf61.svg";